<div class="menu">
    <p-accordion [ngClass]="className">
        <p-accordionTab *ngIf="showCP" header="{{ 'MainMenu.MenuCP' | translate}}" [selected]="selectedTab == 'CP'">
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-cogs"></i> {{ 'MainMenu.CPFinancialStatement' | translate}}</ng-template>
                <li *ngFor="let menu of itemsCPFinancialStatement">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-cogs"></i> {{ 'MainMenu.CPCustomers' | translate}}</ng-template>
                <li *ngFor="let menu of itemsCPCustomers">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-calculator"></i> {{ 'MainMenu.CPVendors' | translate}}</ng-template>
                <li *ngFor="let menu of itemsCPVendors">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-satellite-dish"></i> {{ 'MainMenu.CPRevenues' | translate}}</ng-template>
                <li *ngFor="let menu of itemsCPRevenues">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-list-ol"></i> {{ 'MainMenu.CPCost' | translate}}</ng-template>
                <li *ngFor="let menu of itemsCPCost">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-file-contract"></i> {{ 'MainMenu.CPManagements' | translate}}</ng-template>
                <li *ngFor="let menu of itemsCPManagements">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-file-contract"></i> {{ 'MainMenu.CPAnalyze' | translate}}</ng-template>
                <li *ngFor="let menu of itemsCPAnalyze">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            
        </p-accordionTab>
        <!-- <p-accordionTab *ngIf="showCP" header="{{ 'MainMenu.MenuCP' | translate}}" (click)="clickCP()">
        </p-accordionTab> -->
        <p-accordionTab *ngIf="showGL" header="{{ 'MainMenu.MenuGL' | translate}}" [selected]="selectedTab == 'GL'">
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-cogs"></i> {{ 'MainMenu.Msetup' | translate}}</ng-template>
                <li *ngFor="let menu of itemsGLSetup">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-calculator"></i> {{ 'MainMenu.Minput' | translate}}</ng-template>
                <li *ngFor="let menu of itemsGLInput">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-satellite-dish"></i> {{ 'MainMenu.MProcess' | translate}}</ng-template>
                <li *ngFor="let menu of itemsGLProcess">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-list-ol"></i> {{ 'MainMenu.MInquiry' | translate}}</ng-template>
                <li *ngFor="let menu of itemsGLInquiry">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-file-contract"></i> {{ 'MainMenu.MReport' | translate}}</ng-template>
                <li *ngFor="let menu of itemsGLReport">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
        </p-accordionTab>
        <p-accordionTab *ngIf="showAP" header="{{ 'MainMenu.MenuAP' | translate}}" [selected]="selectedTab == 'AP'">
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-cogs"></i> {{ 'MainMenu.Msetup' | translate}}</ng-template>
                <li *ngFor="let menu of itemsAPSetup">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-calculator"></i> {{ 'MainMenu.Minput' | translate}}</ng-template>
                <li *ngFor="let menu of itemsAPInput">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-satellite-dish"></i> {{ 'MainMenu.MProcess' | translate}}</ng-template>
                <li *ngFor="let menu of itemsAPProcess">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-list-ol"></i> {{ 'MainMenu.MInquiry' | translate}}</ng-template>
                <li *ngFor="let menu of itemsAPInquiry">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-file-contract"></i> {{ 'MainMenu.MReport' | translate}}</ng-template>
                <li *ngFor="let menu of itemsAPReport">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
        </p-accordionTab>
        <p-accordionTab *ngIf="showAR" header="{{ 'MainMenu.MenuAR' | translate}}" [selected]="selectedTab == 'AR'">
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-cogs"></i> {{ 'MainMenu.Msetup' | translate}}</ng-template>
                <li *ngFor="let menu of itemsARSetup">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-calculator"></i> {{ 'MainMenu.Minput' | translate}}</ng-template>
                <li *ngFor="let menu of itemsARInput">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-satellite-dish"></i> {{ 'MainMenu.MProcess' | translate}}</ng-template>
                <li *ngFor="let menu of itemsARProcess">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-list-ol"></i> {{ 'MainMenu.MInquiry' | translate}}</ng-template>
                <li *ngFor="let menu of itemsARInquiry">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-file-contract"></i> {{ 'MainMenu.MReport' | translate}}</ng-template>
                <li *ngFor="let menu of itemsARReport">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
        </p-accordionTab>
        <p-accordionTab *ngIf="showCA" header="{{ 'MainMenu.MenuCA' | translate}}" [selected]="selectedTab == 'CA'">
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-cogs"></i> {{ 'MainMenu.Msetup' | translate}}</ng-template>
                <li *ngFor="let menu of itemsCASetup">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-calculator"></i> {{ 'MainMenu.Minput' | translate}}</ng-template>
                <li *ngFor="let menu of itemsCAInput">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-satellite-dish"></i> {{ 'MainMenu.MProcess' | translate}}</ng-template>
                <li *ngFor="let menu of itemsCAProcess">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-list-ol"></i> {{ 'MainMenu.MInquiry' | translate}}</ng-template>
                <li *ngFor="let menu of itemsCAInquiry">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-file-contract"></i> {{ 'MainMenu.MReport' | translate}}</ng-template>
                <li *ngFor="let menu of itemsCAReport">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
        </p-accordionTab>
        <p-accordionTab *ngIf="showFA" header="{{ 'MainMenu.MenuFA' | translate}}" [selected]="selectedTab == 'FA'">
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-cogs"></i> {{ 'MainMenu.Msetup' | translate}}</ng-template>
                <li *ngFor="let menu of itemsFASetup">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-calculator"></i> {{ 'MainMenu.Minput' | translate}}</ng-template>
                <li *ngFor="let menu of itemsFAInput">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-satellite-dish"></i> {{ 'MainMenu.MProcess' | translate}}</ng-template>
                <li *ngFor="let menu of itemsFAProcess">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-list-ol"></i> {{ 'MainMenu.MInquiry' | translate}}</ng-template>
                <li *ngFor="let menu of itemsFAInquiry">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-file-contract"></i> {{ 'MainMenu.MReport' | translate}}</ng-template>
                <li *ngFor="let menu of itemsFAReport">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
        </p-accordionTab>
        <p-accordionTab *ngIf="showIN" header="{{ 'MainMenu.MenuIN' | translate}}" [selected]="selectedTab == 'IN'">
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-cogs"></i> {{ 'MainMenu.Msetup' | translate}}</ng-template>
                <li *ngFor="let menu of itemsINSetup">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-calculator"></i> {{ 'MainMenu.Minput' | translate}}</ng-template>
                <li *ngFor="let menu of itemsINInput">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-satellite-dish"></i> {{ 'MainMenu.MProcess' | translate}}</ng-template>
                <li *ngFor="let menu of itemsINProcess">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-file-contract"></i> {{ 'MainMenu.MReport' | translate}}</ng-template>
                <li *ngFor="let menu of itemsINReport">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
        </p-accordionTab>
        <p-accordionTab *ngIf="showSA" header="{{ 'MainMenu.MenuSA' | translate}}" [selected]="selectedTab == 'SA'">
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-cogs"></i> {{ 'MainMenu.Msetup' | translate}}</ng-template>
                <li *ngFor="let menu of itemsSASetup">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-calculator"></i> {{ 'MainMenu.Minput' | translate}}</ng-template>
                <li *ngFor="let menu of itemsSAInput">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-file-contract"></i> {{ 'MainMenu.MReport' | translate}}</ng-template>
                <li *ngFor="let menu of itemsSAReport">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
        </p-accordionTab>
        <p-accordionTab *ngIf="showPO" header="{{ 'MainMenu.MenuPO' | translate}}" [selected]="selectedTab == 'PO'">
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-calculator"></i> {{ 'MainMenu.Minput' | translate}}</ng-template>
                <li *ngFor="let menu of itemsPOInput">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-satellite-dish"></i> {{ 'MainMenu.MProcess' | translate}}</ng-template>
                <li *ngFor="let menu of itemsPOProcess">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-file-contract"></i> {{ 'MainMenu.MReport' | translate}}</ng-template>
                <li *ngFor="let menu of itemsPOReport">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
        </p-accordionTab>
        <p-accordionTab *ngIf="showSO" header="{{ 'MainMenu.MenuSO' | translate}}" [selected]="selectedTab == 'SO'">
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-calculator"></i> {{ 'MainMenu.Minput' | translate}}</ng-template>
                <li *ngFor="let menu of itemsSOInput">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-satellite-dish"></i> {{ 'MainMenu.MProcess' | translate}}</ng-template>
                <li *ngFor="let menu of itemsSOProcess">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-file-contract"></i> {{ 'MainMenu.MReport' | translate}}</ng-template>
                <li *ngFor="let menu of itemsSOReport">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
        </p-accordionTab>
        <p-accordionTab *ngIf="showEI" header="{{ 'MainMenu.MenuEI' | translate}}" [selected]="selectedTab == 'EI'">
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-cogs"></i> {{ 'MainMenu.Msetup' | translate}}</ng-template>
                <li *ngFor="let menu of itemsEISetup">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-calculator"></i> {{ 'MainMenu.Minput' | translate}}</ng-template>
                <li *ngFor="let menu of itemsEIInput">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-satellite-dish"></i> {{ 'MainMenu.MProcess' | translate}}</ng-template>
                <li *ngFor="let menu of itemsEIProcess">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
        </p-accordionTab>
        <p-accordionTab *ngIf="showSI" header="{{ 'MainMenu.MenuShared' | translate}}" [selected]="selectedTab == 'SI'">
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-calculator"></i> {{ 'MainMenu.Minput' | translate}}</ng-template>
                <li *ngFor="let menu of itemsSIInput">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
        </p-accordionTab>
        <p-accordionTab *ngIf="showUF" header="{{ 'MainMenu.MenuUF' | translate}}" [selected]="selectedTab == 'UF'">
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-tools"></i> {{ 'MainMenu.MenuUF' | translate}}</ng-template>
                <li *ngFor="let menu of itemsUFInput">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
        </p-accordionTab>
        <p-accordionTab *ngIf="showST" header="{{ 'MainMenu.MenuST' | translate}}" [selected]="selectedTab == 'ST'">
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-shield-alt"></i> {{ 'MainMenu.cmdUtility' | translate}}</ng-template>
                <li *ngFor="let menu of itemsSTSecurity">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
        </p-accordionTab>
        <p-accordionTab *ngIf="showBG" header="{{ 'MainMenu.MenuBG' | translate}}" [selected]="selectedTab == 'BG'">
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-cogs"></i> {{ 'MainMenu.Msetup' | translate}}</ng-template>
                <li *ngFor="let menu of itemsBGInput">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-file-contract"></i> {{ 'MainMenu.MReport' | translate}}</ng-template>
                <li *ngFor="let menu of itemsBGReport">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
        </p-accordionTab>
        <p-accordionTab *ngIf="showSP" header="{{ 'MainMenu.MenuSP' | translate}}" [selected]="selectedTab == 'SP'">
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-cogs"></i> {{ 'MainMenu.Msetup' | translate}}</ng-template>
                <li *ngFor="let menu of itemsSPInput">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
            <p-fieldset>
                <ng-template pTemplate="header"><i style="color: #0ABDA0;" class="fas fa-file-contract"></i> {{ 'MainMenu.MReport' | translate}}</ng-template>
                <li *ngFor="let menu of itemsSPReport">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
        </p-accordionTab>
        <p-accordionTab *ngIf="showAS" header="{{ 'MainMenu.MenuAS' | translate}}" (click)="clickAS()">
        </p-accordionTab>
        <p-accordionTab *ngIf="showHR" header="{{ 'MainMenu.MenuHR' | translate}}" (click)="clickHR()">
        </p-accordionTab>
    </p-accordion>
</div>